export const limitCount = 500000

export const MAPBOX_TOKEN = 'pk.eyJ1Ijoic2FjZXR0ZSIsImEiOiJjazg5bDJ5Y2kwODVrM2xxejRsMGx3NHpiIn0.UL6qpwGMeZC2566ggU__cQ'
